import { useCallback, useEffect, useRef, useState } from 'react'
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector, useStore } from 'react-redux'
import { Button, Stack, Typography } from '@mui/material'
import { useReactFlow } from '@xyflow/react';
import { setSurveyFlow, setSurveyHaveDraft } from '../../../actions/surveyFlowAction'
import SurveyDialog from './SurveyDialog'
import SurveyFlow from '../SurveyFlow'
import { getOne, post, put } from '../../../helper/baseFetch';
import { API_PATH } from '../../../Constants/path';
import { KEYS_OF_FILTER_KEY_LIST, KEYS_OF_HAVE_DRAFT, KEYS_OF_IS_CREATE, KEYS_OF_TEMP_DRAFT_DATA, KEYS_OF_WITHOUT_OPTIONS, PREFIX_OF_TEMP_NODE } from '../constant';
import BottomBarFromEditCreateDisplay from '../../_v2/common/BottomBarFromEditCreateDisplay';
import SaveIcon from '@mui/icons-material/Save'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import HelpIcon from '@mui/icons-material/Help';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import MUICard from '../../common/card/MUICard';
import CardTitle from '../../common/card/CardTitle';
import { constants } from '../../../Constants/constants';
import { GlobalDialog } from '../../GlobalDialog';
import useUpload from '../hooks/useUpload';
import useFilterKey from '../hooks/useFilterKey';


const noDataSx = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 1
}

// survey detail page
export default function SurveyPanel() {

    const store = useStore()
    const savedSurveyFlow = useSelector(state => state.surveyFlow.ui.surveyFlow)
    const dispatch = useDispatch()

    const params = useParams()
    const location = useLocation()
    const history = useHistory()

    const { getNodes, getEdges } = useReactFlow();

    const { convertExcelToJson } = useUpload()
    const { init } = useFilterKey(KEYS_OF_FILTER_KEY_LIST)

    const [editDialogOpen, setEditDialogOpen] = useState(false)
    const [data, setData] = useState({})
    const [dialog, setDialog] = useState({
        open: false,
        dialogActions: [],
    })
    const [uploadFile, setUploadFile] = useState({
        common: {},
        detail: []
    })

    const uploadIptRef = useRef(null)

    const handleGetOne = () => {
        getOne(
            API_PATH.survey.detail + `/${params?.id}`,
            undefined,
            (result) => {
                const filteredResult = {
                    ...result,
                    questionList: result?.questionList?.sort((first, second) => first.sequence - second.sequence)
                }
                setData(filteredResult)
                updateSubmitDataToStore(filteredResult)

                const existingFilterKey = result?.questionList?.map(i => ({ value: i?.filterKey, ts: Number.MAX_SAFE_INTEGER })).filter(i => i.value)
                init(existingFilterKey)
            },
            undefined,
            store
        )
    }

    const handleSave = () => {
        const allEdges = getEdges()
        const payload = {
            ...savedSurveyFlow,
            questionList: getNodes().map(node => {
                const newData = {
                    ...node?.data,
                    sequence: Number.isNaN(Number(node?.data?.sequence)) ? 10 : Number(node?.data?.sequence),
                    // nextQuestionMap: allEdges.filter(i => i?.source == node?.data?.id).map(i => i.target),
                    // parentQuestionId: allEdges.filter(i => i.target == node?.data?.id).map(i => i.source)
                    nextQuestionMap: null,
                    parentQuestionId: null,
                }

                if(newData?.id && String(newData?.id).startsWith(PREFIX_OF_TEMP_NODE)) {
                    delete newData?.id
                }

                if (KEYS_OF_WITHOUT_OPTIONS.includes(newData?.type)) newData.answerOptionList = null

                return newData
            }).sort((first, second) => first?.sequence - second.sequence)
        }

        if(payload?.id && String(payload?.id).startsWith(PREFIX_OF_TEMP_NODE)) {
            delete payload?.id
        }

        if (savedSurveyFlow?.id) {
            put(
                API_PATH.survey.detail + `/${savedSurveyFlow?.id}`,
                payload,
                (result) => {
                    updateSubmitDataToStore(result)
                },
                undefined,
                store
            )
        } else {
            post(
                API_PATH.survey.base,
                payload,
                (result) => {
                    history.replace(`/${constants.PATH.SURVEY.BASE}/` + result?.id)
                    updateSubmitDataToStore(result)
                },
                undefined,
                store
            )
        }
    }

    const handleToggleStatus = () => {
        put(
            API_PATH.survey.status + `/${savedSurveyFlow?.id}`,
            {
                status: savedSurveyFlow?.status == 'A' ? 'P' : 'A'
            },
            (result) => {
                setDialog({
                    open: true,
                    onClose: onClickBackToEdit,
                    dialogContentText: { key: 'editSuccess' },
                    dialogActions: [
                        { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
                        { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
                    ],
                })
            },
            undefined,
            store
        )
    }

    const handleDelete = () => {
        put(
            API_PATH.survey.status + `/${savedSurveyFlow?.id}`,
            {
                status: 'D'
            },
            (result) => {
                history.replace(`/${constants.PATH.SURVEY.BASE}`)
            },
            undefined,
            store
        )
    }

    const onClickBackToEdit = (callGetOne = true) => {
        setDialog({
            open: false,
            dialogActions: [],
        })
        if (callGetOne) handleGetOne()
    }

    const onClickBackToList = () => {
        setDialog({
            open: false,
            dialogActions: [],
        })
        history.push('/' + constants.PATH.SURVEY.BASE)
    }

    const deleteDialog = () => {
        setDialog({
            open: true,
            onClose: () => onClickBackToEdit(false),
            dialogContentText: { key: 'deleteContent' },
            dialogActions: [
                { label: { key: 'close' }, onClick: () => onClickBackToEdit(false), icon: <CloseIcon /> },
                { label: { key: 'confirm' }, onClick: handleDelete, icon: <DoneIcon /> },
            ],
        })
    }

    const initUploadFileListener = () => {
        const fileInput = document.getElementById('uploadFile');

        fileInput.addEventListener('change', async (event) => {
            const file = event.target.files[0];
            const result = await convertExcelToJson(file);
            if (result) {
                setUploadFile(result)
            }
        });
    }

    const helpDialog = () => {
        setDialog({
            open: true,
            onClose: () => onClickBackToEdit(false),
            help: true,
            helpContentArray: [
                { key: 'helpForSurveyClone' },
                { key: 'helpForSurveyDelete' },
            ],
            dialogActions: [
                { label: { key: 'close' }, onClick: () => onClickBackToEdit(false), icon: <CloseIcon /> },
            ],
        })
    }

    const updateSubmitDataToStore = useCallback((data) => {
        dispatch(setSurveyFlow(data))
        setEditDialogOpen(false)
    }, [])

    const bottomBtns = [
        {
            label: { key: 'save' },
            onClick: handleSave,
            className: 'margin-right-16',
            icon: <SaveIcon />,
            disabled: false,
        },
        {
            label: { key: 'edit' },
            onClick: () => setEditDialogOpen(true),
            className: 'margin-right-16',
            icon: <EditIcon />,
            disabled: false,
        },
        // {
        //     label: { key: 'import' },
        //     onClick: () => uploadIptRef.current?.click(),
        //     className: 'margin-right-16',
        //     icon: <UploadFileIcon />,
        //     disabled: false,
        // },
        {
            label: { key: 'help' },
            onClick: helpDialog,
            className: 'margin-right-16',
            icon: <HelpIcon />,
            disabled: false,
        },
        {
            variant: constants.STYLE.VARIANT.CONTAINED,
            color: (savedSurveyFlow.status == 'A') ? constants.STYLE.ERROR : constants.STYLE.SUCCESS,
            icon: (savedSurveyFlow.status == 'A') ? <PowerOffIcon /> : <PowerIcon />,
            label: { key: (savedSurveyFlow.status == 'A') ? 'disabled' : 'enabled' },
            className: 'special-button-margin-left margin-right-16',
            onClick: handleToggleStatus,
        },
        new URLSearchParams(location?.search).get(KEYS_OF_IS_CREATE) ? null : {
            color: constants.STYLE.ERROR,
            label: { key: 'deleteBtn' },
            onClick: deleteDialog,
            className: 'margin-right-16',
            icon: <DeleteIcon />,
            disabled: false,
        }
    ].filter(i => i)

    // useEffect(() => {
    //     const data = {...savedSurveyFlow, ...uploadFile?.common, questionList: [...savedSurveyFlow?.questionList, ...uploadFile?.detail]}
    //     dispatch(setSurveyFlow(data))

    //     // empty the last upload file value
    //     uploadIptRef.current.value = null
    // }, [uploadFile])

    useEffect(() => {

        initUploadFileListener()

        if (params?.id) {
            // temp node skip getOne, usually in create mode
            if (params?.id?.includes(PREFIX_OF_TEMP_NODE)) return;

            // skip getOne, take draft data
            if (new URLSearchParams(location?.search).get(KEYS_OF_HAVE_DRAFT)) {
                const fromLocal = localStorage.getItem(KEYS_OF_TEMP_DRAFT_DATA)
                const result = fromLocal ? JSON.parse(fromLocal) : {}
                const filteredResult = {
                    ...result,
                    questionList: result?.questionList?.sort((first, second) => first.sequence - second.sequence)
                }

                setData(filteredResult)
                updateSubmitDataToStore(filteredResult)
                localStorage.removeItem(KEYS_OF_TEMP_DRAFT_DATA)
                return
            }

            handleGetOne()
        }
    }, [])

    return (
        <MUICard
            header={
                <CardTitle>
                    Edit Survey:  ({params?.id}) {savedSurveyFlow?.title?.EN}
                </CardTitle>
            }
            actions={<BottomBarFromEditCreateDisplay bottomBtns={bottomBtns} />}
            sx={{ gap: 0 }}
        >
            {/* edit dialog */}
            <SurveyDialog
                isEdit={true}
                open={editDialogOpen}
                toggleOpen={setEditDialogOpen}
                handleSubmit={updateSubmitDataToStore}
            />

            {/* main flow canvas */}
            <SurveyFlow
                initList={data?.questionList}
                updateDataToStore={updateSubmitDataToStore}
                handleSave={handleSave}
            />

            {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}

            {/* for upload */}
            <input ref={uploadIptRef} hidden type="file" name="uploadFile" id="uploadFile" />
        </MUICard>
    )
}
